module.exports = __webpack_public_path__ + "static/media/cancel_icon.5db5fd73.svg";